export default __webpack_public_path__ + "static/media/teste-covid.555c1a0e.png";